<template>
  <div>
    <div class="crumbs-navigate">
      <div class="wrapper">
        <div class="crumbs-navigate-text">
          <ct-button class="init-button" @click="goRoute('/question-collection')">
            <ct-icon name="list" class="list-icon"></ct-icon>
          </ct-button>
          <span>mistake collection</span>
          <ct-icon name="mianbao" class="erji-icon"></ct-icon>
          <span v-if="wrongList[index]">{{ wrongList[index].text }}</span>
          <ct-icon name="mianbao" class="erji-icon"></ct-icon>
          <span v-if="wrongList[index]">Question ID： {{ wrongList[index].question_id }}</span>
        </div>
      </div>
    </div>
    <div class="sub-content-container">
      <div class="wrapper">
        <div class="float-block">
          <v-card class="note-box">
            <h2 class="note-box-title">Your thoughts</h2>
            <textarea
              class="note-text"
              v-model.trim="currentText"
              maxlength="500"
              placeholder="A specific description on the mistake will help us correct this question rapidly"
            ></textarea>
            <div class="text-length-box clearfix">
              <span>{{ currentText.length }}</span> / 500
            </div>
            <ct-button type="primary" @click="submitNote" :isLoading="noteLoading" size="small">Submit</ct-button>
          </v-card>
        </div>
        <v-question
          :key="index"
          v-if="wrongList.length"
          :questionList="wrongList"
          :index="index"
          :visibleRightAnswer="showAnswer"
        />
      </div>
    </div>
    <div
      class="scrollbar fixed">
      <div class="wrapper">
        <div class="issue-detail-footer-content">
          <div class="issue-pagenation-box">
            <span @click="increase" :class="{disab: index === 0}" class="issue-pg-second-box">
              Last question
              <span>
                <ct-icon style="transform: rotate(180deg);" name="jiantouyou"></ct-icon>
              </span>
            </span>
            <span @click="plus" :class="{disab: index === wrongTotal - 1}" class="issue-pg-second-box">
              <span>
                <ct-icon name="jiantouyou"></ct-icon>
              </span>
              Next question
            </span>
          </div>
          <ct-button type="secondary" @click="changeShow" size="small">
            <ct-icon :name="showAnswer ? 'eye-close' : 'eye-open'"></ct-icon>
            solution
          </ct-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Question from '../question/Question'
import api from '../../api'
import Card from '../../components/Card'
export default {
  name: 'IssueDetail',
  components: {
    'v-question': Question,
    'v-card': Card
  },
  data () {
    return {
      wrongList: [],
      showAnswer: false,
      currentText: '',
      offsetTop: 0,
      noteLoading: false
    }
  },
  methods: {
    goRoute (routePath) {
      this.$router.push(routePath)
    },
    submitNote () {
      if (this.noteLoading) return
      if (this.currentText.length > 500) {
        this.$toast('notes can\'t be longer than 500 words')
        return
      }
      this.noteLoading = true
      api.addWrongNote({
        data: {
          question_id: this.wrongList[this.index].question_id,
          note: this.currentText
        }
      }).then(res => {
        this.noteLoading = false
        if (res.data && res.data.code === 1) {
          this.wrongList[this.index].note = this.currentText
          this.$toast({ message: 'Your note has been saved!', type: 'success', duration: 2000 })
        } else {
          this.$toast({ message: res.data.error, type: 'warning', duration: 2000 })
        }
      }, () => {
        this.noteLoading = false
      })
    },
    increase () {
      if (this.index <= 0) return
      this.$router.push({
        name: 'questionDetail',
        params: {
          origin: this.$route.params.origin,
          index: this.$route.params.index - 1
        }
      })
    },
    plus () {
      if (this.index >= this.wrongTotal - 1) return
      this.$router.push({
        name: 'questionDetail',
        params: {
          origin: this.$route.params.origin,
          index: this.$route.params.index - 0 + 1
        }
      })
    },
    filterArr (arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].online !== 1) {
          arr.splice(i, 1)
          i -= 1
        }
      }
      return arr
    },
    changeShow () {
      this.showAnswer = !this.showAnswer
    }
  },
  computed: {
    wrongTotal () {
      return this.wrongList.length
    },
    origin () {
      return this.$route.params.origin - 0
    },
    index () {
      return this.$route.params.index - 0
    }
  },
  watch: {
    index (newVal, oldVal) {
      this.showAnswer = false
      if (newVal > this.wrongList.length - 1 || newVal < 0) {
        this.$router.push({
          name: 'questionDetail',
          params: {
            origin: this.$route.params.origin,
            index: 0
          }
        })
        return
      }
      this.currentText = this.wrongList[newVal].note
    }
  },
  mounted () {
    api.getWrongQuestionList({
      params: {
        parent_id: this.origin,
        order: 1,
        is_detail: 1
      }
    }).then(res => {
      let data = res.data
      if (data.code === 1) {
        data = data.data.list
        if (this.index > data.length - 1 || this.index < 0) {
          this.$router.push({
            name: 'questionDetail',
            params: {
              origin: this.$route.params.origin,
              index: 0
            }
          })
          return
        }
        this.wrongList = this.filterArr(data)
        this.currentText = this.wrongList[this.index].note
      }
    })
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
$navigate-height: 76px;
$mianbao-height: 46px;
@import '@/styles/_varaible.scss';
  .crumbs-navigate{
    position:fixed;
    z-index: 1100;
    width: 100%;
    top: $navigate-height;
    background: #fff;
    box-shadow:0px 2px 14px 0px rgba(79,117,162,0.07);
    font-size:14px;
    font-family:SFProDisplay-Regular;
    font-weight:400;
    color:rgba(186,196,206,1);
    line-height:14px;
    &-text{
      font-size:14px;
      font-family:SFProDisplay-Regular;
      font-weight:400;
      color:#BAC4CE;
      padding: 12px 0;
      line-height:14px;
    }
    .init-button{
      padding: 0;
    width: auto;
    min-width: auto;
    height: auto;
    }
    .list-icon{
      margin-right: 8px;
      color:#1A3D5E;
      cursor: pointer;
      font-size: 20px;
      vertical-align: middle;
    }
    .erji-icon{
      vertical-align: middle;
      margin: 0 14px;
    }
    .switcher-container{
      height: 32px;
      position:absolute;
      line-height: 32px;
      right: 0;
      top: 7px;
    }
  }
  .sub-content-container{
    margin-top: $mianbao-height+8;
    min-height: 75vh;
    .float-block{
      width:316px;
      float: right;
      text-align: center;
      &:before,
      &:after {
        content: " ";
        display: table;
      }
      .note-box {
        padding: 24px 15px 36px;
        .note-box-title {
          font-size:16px;
          font-weight:500;
          color:rgba(26,61,94,1);
          line-height:16px;
          text-align: center;
          margin-bottom: 16px;
        }
        .note-text {
          width: 100%;
          height: 286px;
          resize: none;
          padding: 12px;
          font-size:14px;
          font-weight:400;
          color:rgba(26,61,94,1);
          line-height:22px;
          border: 1px solid #DAE0E5;
          outline: none;
          &::placeholder {
            color: #BAC4CE;
          }
        }
        .text-length-box {
          font-size:14px;
          font-weight:400;
          color:#A3B1BF;
          line-height:14px;
          text-align: right;
          margin-top: 8px;
          margin-bottom: 24px;
          span {
            color: #1A3D5E;
          }
        }
      }
    }
  }
  .scrollbar.fixed {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    box-shadow:0px 2px 14px 0px rgba(79,117,162,0.07);
    .issue-detail-footer-content {
      margin-right: 327px;
      display: flex;
      height: 60px;
      justify-content: space-between;
      align-items: center;
      .issue-pagenation-box {
        height: 60px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .issue-pg-second-box {
          font-size:14px;
          font-family:SFProDisplay-Regular;
          font-weight:400;
          color:rgba(26,61,94,1);
          line-height:16px;
          margin: 0 4px;
          cursor: pointer;
          &:hover {
            color:#37cad7;
          }
          &.disab {
            opacity: .3;
            box-shadow: 0px 2px 12px 0px rgba(79, 117, 162, 0.07);
            cursor: not-allowed;
            color:rgba(26,61,94,1);
          }
          >span {
            display: inline-block;
            width:40px;
            height:40px;
            background:rgba(239,244,250,1);
            border-radius:2px;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
          }
        }
      }
    }
  }
  // question
</style>
